import {
  AuthState,
  LoginTypes,
  SET_CLEAN_USER,
  SET_ERROR_MESSAGE,
  SET_IS_ERROR,
  SET_LOADING_LOGIN,
  SET_USER,
  UserActionTypes,
} from "./types";

export function signInRequest(
  token: string | undefined,
  login: string | undefined
) {
  return {
    type: LoginTypes.SIGN_IN_REQUEST,
    payload: { token, login },
  };
}

export function setUser(payload: AuthState): UserActionTypes {
  return {
    payload,
    type: SET_USER,
  };
}
export function setLoginErrorMessage(payload: string): UserActionTypes {
  return {
    payload,
    type: SET_ERROR_MESSAGE,
  };
}

export function setLoadingLogin(payload: boolean): UserActionTypes {
  return {
    payload,
    type: SET_LOADING_LOGIN,
  };
}

export function setLoginIsErrorMessage(payload: boolean): UserActionTypes {
  return {
    payload,
    type: SET_IS_ERROR,
  };
}
export function setCleanUser(): UserActionTypes {
  return {
    type: SET_CLEAN_USER,
  };
}
